import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  ContinueWithBackAndTempSaveButtons,
} from 'components/base/BottomStepComponent';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';
import {
  APIStatus,
  ActionType,
  CampaignType,
} from 'config/CustomEnums';

import '../../campaign/campaignCreation/CreateCampaignStepFour.scss';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATION_STEP_THREE_CONFIG } from './StampCampaignCreationConfig';

import StampCard from "assets/images/campaignStreamline/preview_stamp_card.svg"
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';

function CreateStampCampaignStepThreeV2({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  onStepChange,
  onSaveTemp,
}) {
  const params = useParams();
  const campaignId = params.id
  const isEditMode = !!campaignId
  const formContext = useFormContext();
  const { getValues, setValue } = formContext;
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  useEffect(() => {
    const executionPriority = getValues("executionPriority");
    if (!executionPriority) {
      setValue("executionPriority", 1, { shouldDirty: true });
    };
  }, []);
  
  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_THREE_CONFIG}
        inputWithImageConfig={{}}
        defaultImage={StampCard}
      />
      <ContinueWithBackAndTempSaveButtons
        backAction={() => {
          onStepChange(1);
        }}
        {...isEditMode ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            onSaveTemp && onSaveTemp(formContext)
          }
        }}
        continueAction={() => {
          onStepChange(3);
        }}
      />

      <PublishCampaignPrompt
        campaignId={campaignId}
        campaignType={CampaignType.stampCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/stamp_campaigns'}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
  isSuperuser: state.users.isSuperuser,
  userPermissions: state.users.userPermissions,
});

export default connect(mapPropsToState)(CreateStampCampaignStepThreeV2);
